import React from 'react';
import PropTypes from 'prop-types';
import { Tr, Td } from 'oxyrion-ui/lib/Table';
import { connect } from '../../Store';

class InfoTableRow extends React.Component {
  renderCell(
    data,
    center = false,
    right = false,
    left = false,
    colorLabel = false,
    flag = false,
  ) {
    return (
      <Td
        center={center}
        right={right}
        left={left}
        colorLabel={colorLabel}
        flag={flag}
      >
        {data}
      </Td>
    );
  }

  render() {
    const { cells, disabled, rowHover } = this.props;

    return (
      <Tr disabled={disabled} rowHover={rowHover}>
        {cells.map(cell => {
          return this.renderCell(
            cell.data,
            cell.center,
            cell.right,
            cell.left,
            cell.colorLabel,
            cell.flag,
          );
        })}
      </Tr>
    );
  }
}

InfoTableRow.propTypes = {
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.element,
      center: PropTypes.bool,
      right: PropTypes.bool,
      left: PropTypes.bool,
      colorLabel: PropTypes.string,
      flag: PropTypes.string,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  rowHover: PropTypes.bool,
};

InfoTableRow.defaultProps = {
  disabled: false,
  rowHover: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InfoTableRow);



// WEBPACK FOOTER //
// ./src/Components/InfoTableRow/index.jsx